import { useEffect, useRef } from 'react';

/**
 * Simple hook which enables to check if the trigger of the useEffect is
 * on initial mount.
 */
export const useIsMount = () => {
  const isMountRef = useRef(true);
  useEffect(() => {
    isMountRef.current = false;
  }, []);
  return isMountRef.current;
};
